import classNames from 'classnames/bind';
import Link from 'next/link';
import React from 'react';
import styles from './index.module.scss';

export interface ButtonProps {
  text: string;
  href?: string;
  style?: React.CSSProperties;
  arrow?: boolean;
  diap?: boolean;
  outline?: boolean;
  children?: React.ReactNode;
  onClick?: (event?: any) => void;
}

export const Button = ({
  text,
  href,
  children,
  onClick,
  style,
  arrow,
  diap,
  outline,
}: ButtonProps) => {
  const cx = classNames.bind(styles)(
    'button',
    { arrow: arrow },
    { diap: diap },
    { outline: outline },
  );

  if (href)
    return (
      // @ts-ignore
      <Link href={href} className={cx} style={style}>
        <span>{text ?? children}</span>
      </Link>
    );

  if (!href)
    return (
      <span className={cx} style={style} onClick={onClick}>
        <span>{text ?? children}</span>
      </span>
    );

  return null;
};

Button.defaultProps = {
  href: '',
  arrow: false,
  diap: false,
  outline: false,
} as Partial<ButtonProps>;
